import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Layout/search/index.js")